import {Component, ElementRef, Input, OnChanges, ViewChild} from '@angular/core';
import {SupportArticle} from '../../../models/supportArticle';
import {Title} from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs';
import {SupportService} from '../../../shared/services/support.service';

@Component({
    selector: 'course-support-detail',
    templateUrl: './supportDetail.component.html',
    styleUrls: ['./supportDetail.component.scss'],
})
export class SupportDetailComponent implements OnChanges {
    @Input() article: SupportArticle;
    @Input() slugs: string[];
    @ViewChild('menu') menu: ElementRef;
    @ViewChild('content') content: ElementRef;
    tree: SupportArticle;
    parents: SupportArticle[] = [];
    slugPath: BehaviorSubject<string> = new BehaviorSubject<string>('');

    constructor(
        private supportService: SupportService,
        private title: Title,
    ) {}

    ngOnChanges() {
        this.tree = this.supportService.getArticles();
        this.setParents();
        this.setTitle();
    }

    /**
     * Determine the parent(s) of the current article.
     * Could be recursive but atm everything is limited to 3 levels deep so yeah.
     */
    setParents() {
        // top level
        let parent = this.tree;
        this.parents = [parent];

        if (this.slugs.length > 1) {
            // first level
            parent = parent.children.filter(
                (child) => {
                    return child.slug === this.slugs[0];
                }
            )[0];
            this.parents.push(parent);

            if (this.slugs.length > 2) {
                // second level
                parent = parent.children.filter(
                    (child) => {
                        return child.slug === this.slugs[1];
                    }
                )[0];
                this.parents.push(parent);
            }
        }

        this.setSlugPath();
    }

    setSlugPath() {
        let slugPath = '';
        this.parents.forEach(
            (parent) => {
                slugPath += '/' + parent.slug;
            }
        );

        slugPath += '/' + this.article.slug;

        this.slugPath.next(slugPath);
    }

    setTitle() {
        let title = this.article.title;

        this.parents.reverse().forEach((parent) => {
            title += ' - ' + parent.title;
        });

        title += ' - Tyyp';

        this.title.setTitle(title);
    }

    isMatIcon(icon: string) {
        return !icon.includes('.svg');
    }
}

